// extracted by mini-css-extract-plugin
export default {"zr-image":"Image_zr-image__+OEmO"};